import React from 'react'
import { Switch, Route, withRouter } from 'react-router-dom'
import { TransitionGroup, CSSTransition } from 'react-transition-group'

import Intro from './containers/Intro/'
import Home from './containers/Home/'
import CS from './containers/CS/'
import Music from './containers/Music/'

import './app.css'

function Container({ location }) {
  // console.log("key will be ", location.pathname + location.hash)

  const routes = [
    { path: '/home', Component: Home, key: 'home' },
    { path: '/cs', Component: CS, key: 'cs' },
    { path: '/music', Component: Music, key: 'music' },
    { path: '/', Component: Intro, key: 'intro' }
  ]

  return (
    <div>
      {/* <TransitionGroup className="transition-group"> */}
      <div className="transition-group">
        <section className="route-section">
          <Switch location={location}>
            {routes.map(({ path, Component }) => (
              <Route key={path + location.hash} exact path={path}>
                {({ match }) => (
                  <CSSTransition
                    in={match !== null}
                    timeout={300}
                    classNames="fade"
                    unmountOnExit
                  >
                    <Component />
                  </CSSTransition>
                )}
              </Route>
            ))}
          </Switch>
        </section>
      </div>
      {/* </TransitionGroup> */}
    </div>
  )
}

export default withRouter(Container)



// WEBPACK FOOTER //
// ./src/Container.js